module.exports = __webpack_public_path__ + "img/user.740b8e65.png";